import styled, { CSSObject } from '@emotion/styled'

interface Props
  extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label: string
  variant?: 'countryCode' | 'textbox' | 'password'
  type: string
  showError?: boolean
  testId?: string
  labelSize?: string
}

const Container = styled.div(
  (): CSSObject => ({
    position: 'relative',
    marginBottom: '16px',
    width: '100%'
  })
)

const Input = styled.input<{ showError: boolean }>(
  ({ theme, showError }): CSSObject => ({
    width: '100%',
    height: '40px',
    fontSize: theme.fontSizes[2],
    fontWeight: theme.fontWeights.light,
    padding: '8px 15px',
    outline: 0,
    border: showError
      ? `1px solid ${theme.colors.state.error[5]}`
      : '1px solid lightgrey',
    borderRadius: theme.borderRadius,

    '&:focus': {
      border: `2px solid ${theme.colors.primary}`
    }
  })
)

const Textarea = styled.textarea((props: any) => ({
  width: '100%',
  height: '80px',
  fontSize: props.theme.fontSizes[2],
  fontWeight: props.theme.fontWeights.light,
  padding: '8px 15px',
  outline: 0,
  border: '1px solid lightgrey',
  borderRadius: '20px',
  '&:focus': {
    border: `2px solid ${props.theme.colors.primary}`
  }
}))

const Label = styled.label((props: any) => ({
  marginBottom: props.labelSize === 'small' ? '4px' : '8px',
  display: 'block',
  fontSize:
    props.labelSize === 'small'
      ? props.theme.fontSizes[0]
      : props.theme.fontSizes[1],
  color: props.theme.colors.textBody
}))

const InputField = ({
  testId,
  label = '',
  labelSize,
  variant = 'password',
  placeholder = '',
  readOnly = false,
  type = '',
  showError,
  ...rest
}: Props) => {
  return (
    <Container>
      <Label labelSize={labelSize}>{label}</Label>
      {variant === 'textbox' ? (
        <Textarea {...rest} datatestid={testId} />
      ) : (
        <Input
          type={type}
          showError={!!showError}
          {...rest}
          data-testid={testId}
        />
      )}
    </Container>
  )
}

export default InputField
